<template>
  <div>
    <!-- MODAL-->
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-history
      class="waves-effect"
      variant="outline-primary"
      @click="getListHistory">
        {{$t('form_history_handling')}}
    </b-button>
    <b-modal
      id="modal-history"
      cancel-variant="outline-secondary"
      hide-footer="true"
      scrollable
      size="xl"
      title="Histórico de tratamento">
      <b-table
              hover
              caption-top
              small
              responsive="sm"
                :items="listItems"
                :fields="fieldsTable">
          <template #cell(status)="data">
            {{_.get(data.item.status, 'label', data.item.status_str) }}
          </template>
          <template #cell(user)="data">
            {{ data.item.user != null? data.item.user.name : ''}}
          </template>
          <template  #cell(public_access)="{item: {public_access}}">
            {{ public_access == 1 ? 'Sim' : 'Não'}}
          </template>
          <template #cell(description)="{item: {description}}">
            <span class="break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content" v-html-safe="description"/>
          </template>
          <template #cell(forwarding_description)="{item: {forwarding_description}}">
            <span class="break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content" v-html-safe="forwarding_description"/>
          </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>

import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  VBTooltip
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BContainer,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BRow,
    BCol,
    BForm,
    BButton,
    BTable
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    isTextTreatmentOnly: {
      type: Boolean,
      default: false
    },
    serviceDelegate: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    showModal: false,
    listItems: [],
    fieldsTable: [
        // A virtual column that doesn't exist in items
        //'index',
        // A column that needs custom formatting
        { key: 'created_date_formatted', label: 'Data/Hora' },
        { key: 'user', label: 'Usuário' },
        { key: 'status', label: 'Situação' },
        { key: 'description', label: 'Tratamento' },
        { key: 'public_access', label: 'Público (tratamento)' },
        { key: 'forwarding_description', label: 'Encaminhamento' },
    ],
  }),
  computed: {

  },
  methods: {
    getListHistory(){
      this.$vs.loading()
      this.serviceDelegate.listHandlingHistory(this.id).then(
        data => {
          this.listItems = data
        },
        error => {}
      ).finally(() => this.$vs.loading.close())
    },
    formatDate(timestamp) {
      const format = 'ddd, DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
  },
  beforeMount() {

  }
}
</script>
<style lang="scss" scoped>
    ::v-deep #full-screen-modal > .modal-dialog {
        max-width: 100%;
    }
</style>

